export default "__VITE_ASSET__DkQH3I$8__"